import {
  EntityCategory,
  selectDetections,
  useDetectedEntitiesStore,
} from '../stores/useDetectedEntitiesStore';
import GroupedEntityData from './GroupedEntityData';
import SimpleEntityData from './SimpleEntityData';
import { memo } from 'react';

type Props = {
  entityType: string;
  category: EntityCategory;
};

function EntityDataPanel({ entityType, category }: Props) {
  const detections = useDetectedEntitiesStore(state =>
    selectDetections(state, category, entityType),
  );

  if (detections.length === 0) {
    return null;
  }

  if (detections[0].isConflictable) {
    return <GroupedEntityData entityType={entityType} category={category} />;
  }

  return (
    <>
      <SimpleEntityData detectionId={detections[0].id} category={category} />
    </>
  );
}

export default memo(EntityDataPanel);
